module.exports = __webpack_public_path__ + "static/media/delete_outline.6a525f66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/delete_outline.svg
// module id = 484
// module chunks = 0